import { VAULT_LOCKED_UI_EVENT } from '../../store/vaultStore';

/**
 * What the "On this page" rail last showed for each document (owner,
 * 14.10.2026: the rail must keep its state like the document text does — no
 * blink when a tab is reopened or the rail toggled). Module-level, so it
 * outlives the rail's mount; the rail starts from it and refreshes quietly.
 *
 *   outline: documentId -> { items, activeId }
 *   linked:  `${userId}:${documentId}` -> items
 *
 * Bounded (oldest dropped) so a long session cannot grow it without limit.
 */
const MAX_ENTRIES = 100;
const outline = new Map();
const linked = new Map();

function put(map, key, value) {
  map.delete(key);
  map.set(key, value);
  if (map.size > MAX_ENTRIES) map.delete(map.keys().next().value);
}

export const readOutline = (documentId) => (documentId ? outline.get(documentId) || null : null);

export function writeOutline(documentId, patch) {
  if (!documentId) return;
  put(outline, documentId, { ...(outline.get(documentId) || { items: null, activeId: null }), ...patch });
}

export const readLinked = (key) => linked.get(key) || null;
export const writeLinked = (key, items) => put(linked, key, items);

/** Locking the vault must not leave connection names in a cached Linked list. */
if (typeof window !== 'undefined') {
  window.addEventListener(VAULT_LOCKED_UI_EVENT, () => linked.clear());
}

/** Tests only. */
export function resetOutlineCache() {
  outline.clear();
  linked.clear();
}
